<div class="terms-conditions-container page-container">
  <mat-tab-group>
    <mat-tab label="{{'termsAndConditionsPolicy' | translate}}">
      <div class="terms-cond-tab">
        <h1>{{'termsAndConditionsPolicy' | translate}}</h1>
        <p class="italic">{{'lastUpdate' | translate}}</p>

        <h2> {{'termsCondTitleH2' | translate}} </h2>
        <p> {{'termsCondP1' | translate}} </p>

        <h3> {{'termsCondH3_1' | translate}} </h3>
        <p> {{'termsCondH3_1_p1' | translate}} </p>
        <p>{{'termsCondH3_1_p2' | translate}}</p>

        <h3> {{'termsCondH3_2' | translate}} </h3>
        <p>{{'termsCondH3_2_p1' | translate}}</p>
        <p>{{'termsCondH3_2_p2' | translate}}</p>

        <h3> {{'termsCondH3_3' | translate}} </h3>
        <p>{{'termsCondH3_3_p1' | translate}}</p>
        <p>{{'termsCondH3_3_p2' | translate}}</p>

        <h3> {{'termsCondH3_4' | translate}} </h3>
        <p>{{'termsCondH3_4_p1' | translate}}</p>

        <h3> {{'termsCondH3_5' | translate}} </h3>
        <p>{{'termsCondH3_5_p1' | translate}}</p>

        <h3>{{'termsCondH3_6' | translate}} </h3>
        <p>{{'termsCondH3_6_p1' | translate}}</p>

      </div>
    </mat-tab>
    <mat-tab label="{{'confidentialityPolicy' | translate}}">
      <div class="privacy-policy-tab">

        <h1>{{'confidentialityPolicy' | translate}}</h1>
        <p class="italic">{{'lastUpdate' | translate}}</p>

        <h2>{{'privacyPolicy_h2' | translate}}</h2>
        <p>{{'privacyPolicy_p1' | translate}}</p>

        <h3>{{'privacyPolicy_h3_1' | translate}}</h3>
        <p>{{'privacyPolicyH3_1_p1' | translate}}</p>
        <p>{{'privacyPolicyH3_1_p2' | translate}}</p>

        <h3>{{'privacyPolicy_h3_2' | translate}}</h3>
        <p>{{'privacyPolicy_h3_2_p1' | translate}}</p>

        <h3>{{'privacyPolicy_h3_3' | translate}}</h3>
        <p>{{'privacyPolicy_h3_3_p1' | translate}}</p>
        <p>{{'privacyPolicy_h3_3_p2' | translate}}</p>
        <p>{{'privacyPolicy_h3_3_p3' | translate}}</p>

        <h3>{{'privacyPolicy_h3_4' | translate}}</h3>
        <p>{{'privacyPolicy_h3_4_p1' | translate}}</p>
        <p>{{'privacyPolicy_h3_4_p2' | translate}}</p>

      </div>
    </mat-tab>
    <mat-tab label="{{'cookiePolicyTitle' | translate}}">
      <div class="cookie-tab">

        <h2>{{'cookiePolicyTitle' | translate}}</h2>
        <p class="italic">{{'lastUpdate' | translate}}</p>

        <h3>{{'cookiePolicy_h3_1' | translate}}</h3>
        <p>{{'cookiePolicy_h3_1_p1' | translate}}</p>

        <h3>{{'cookiePolicy_h3_2' | translate}}</h3>
        <p>{{'cookiePolicy_h3_2_p1' | translate}}</p>
        <p>{{'cookiePolicy_h3_2_p2' | translate}}</p>

        <h3>{{'cookiePolicy_h3_3' | translate}}</h3>
        <p>{{'cookiePolicy_h3_3_p1' | translate}}</p>
        <p>{{'cookiePolicy_h3_3_p2' | translate}}</p>

      </div>
    </mat-tab>
  </mat-tab-group>
</div>
